import { Divider, styled } from '@mui/material';
import { coreThemeColors } from '@youscience/theme';
import { PAGE_BACKGROUND, BACKDROP_OVERLAY } from '@theme';
import { CoreBox } from '@youscience/core';

export const StyledPageInnerContentMargin = styled(CoreBox)(({ theme }) => ({
  padding: '0rem 5rem',
  background: PAGE_BACKGROUND,

  [theme.breakpoints.down('sm')]: {
    padding: '0rem 1rem',
  },
}));

export const StyledPageInnerContentSupportText = styled(CoreBox)(({ theme }) => ({
  padding: '1.5rem 0rem',
  color: BACKDROP_OVERLAY,
}));

export const StyledDivider = styled(Divider)(({ theme }) => ({
  width: '100%',
  gap: '1.5rem',
}));
